// 静态路由
const constantRoutes = [
  {
    path: '/',
    name: 'home',
    component: () =>import('@/views/Home/index.vue'),
    meta: {
      title: 'Home'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () =>import('@/views/Login/index.vue'),
    meta: {
      title: 'Login'
    }
  },
  {
    path: '/products',
    name: 'products',
    component: () => import('@/views/Products/index.vue'),
    meta: {
      title: 'products',
      requiresAuth: false
    },
    children: [
      {
        path: 'list/:id',
        component: () => import('@/views/Products/productList.vue'),
        name: 'productList',
        meta: {
          title: 'productList',
          requiresAuth: false
        }
      }, {
        path: 'details/:id',
        component: () => import('@/views/Products/details.vue'),
        name: 'ProductDetails',
        meta: {
          title: 'ProductDetails',
          requiresAuth: false
        }
      },
    ]
  },
  {
    path: '/applications',
    name: 'Applications',
    component: () => import('@/views/Application/index.vue'),
    meta: {
      title: 'applications',
      requiresAuth: false
    },
    children: [
      {
        path: 'details',
        component: () => import('@/views/Application/details.vue'),
        name: 'ApplicationsDetails',
        meta: {
          title: 'applications',
          requiresAuth: false
        }
      },{
        path: 'solution_item/:id',
        component: () => import('@/views/Application/solution_item.vue'),
        name: 'ApplicationsSolutionItem',
        meta: {
          title: 'solution_item',
          requiresAuth: false
        }
      },
    ]
  },{
    path: '/downloads',
    name: 'Downloads',
    component: () => import('@/views/Downloads/index.vue'),
    meta: {
      title: 'downloads',
      requiresAuth: false
    },
    children: [
      {
        path: 'details',
        component: () => import('@/views/Downloads/details.vue'),
        name: 'DownloadsDetails',
        meta: {
          title: 'downloads',
          requiresAuth: false
        }
      },
    ]
  },
    {
        path: '/manage',
        name: 'Manage',
        component: () => import('@/views/Manage/index.vue'),
        meta: {
          title: 'Manage',
          requiresAuth: true
        },
        children: [
            {
                path: 'manageHomeCarousel',
                component: () => import('@/views/Manage/Home/carousel.vue'),
                name: 'manageHomeCarousel',
                meta: {
                title: 'carousel',
                requiresAuth: true
                }
            },
            {
                path: 'mangeProducts',
                component: () => import('@/views/Manage/products/index.vue'),
                name: 'mangeProducts',
                meta: {
                    title: 'mangeProducts',
                    requiresAuth: true
                }
            },
            {
              path: 'saveProduct',
              component: () => import('@/views/Manage/products/save.vue'),
              name: 'saveProduct',
              meta: {
                  title: 'saveProduct',
                  requiresAuth: true
              }
            },
            {
              path: 'manageSolution',
              component: () => import('@/views/Manage/solution/index.vue'),
              name: 'manageSolution',
              meta: {
                  title: 'manageSolution',
                  requiresAuth: true
              }
            },
            {
                path: 'saveSolution',
                component: () => import('@/views/Manage/solution/save.vue'),
                name:'saveSolution',
                meta: {
                    title:'saveSolution',
                    requiresAuth: true
                }
            },
            {
                path: 'manageNews',
                component: () => import('@/views/Manage/news/index.vue'),
                name: 'manageNews',
                meta: {
                    title: 'news',
                    requiresAuth: true
                }
            },
            {
                path: 'manageDownloads',
                component: () => import('@/views/Manage/downloads/index.vue'),
                name: 'manageDownloads',
                meta: {
                    title: 'downloads',
                    requiresAuth: true
                }
            },
        ]
    },
    {
      path: '/news',
      name: 'news',
      component: () => import('@/views/News/index.vue'),
      meta: {
        title: 'applications',
        requiresAuth: false
      },
      children: [
          {
              path: 'list',
              component: () => import('@/views/News/list.vue'),
              name: 'newsList',
              meta: {
                  title: 'news',
                  requiresAuth: false
              },
          },
          {
              path: ':id',
              component: () => import('@/views/News/details.vue'),
              name: 'newsDetails',
              meta: {
                title: 'news',
                requiresAuth: false
              }
        },
      ]
    },
    {
        path: '/about_us',
        name: 'AboutUs',
        component: () => import('@/views/AboutUs/index.vue'),
        meta: {
            title: 'about_us',
            requiresAuth: false
        },
        children: [
            {
                path: 'about_us_details',
                component: () => import('@/views/AboutUs/details.vue'),
                name: 'AboutUsDetails',
                meta: {
                    title: 'about_us_details',
                    requiresAuth: false
                }
            }
        ]
    },
    {
        path: '/contact_us',
        name: 'ContactUs',
        component: () => import('@/views/ContactUs/index.vue'),
        meta: {
            title: 'contact_us',
            requiresAuth: false
        },
        children: [
            {
                path: 'contact_us_details',
                component: () => import('@/views/ContactUs/details.vue'),
                name: 'ContactUsDetails',
                meta: {
                    title: 'about_us_details',
                    requiresAuth: false
                }
            }
        ]
    }
]

// 动态路由
const asyncRoutes = [
  
]

const routes = {
    constantRoutes,
    asyncRoutes
}

export default routes